export const pwaPath = {
  home: () => "/pwa",
  install: () => "/install",
};
